import React from 'react'
import { Navbar } from '@sketch/components'
import BackButton, { useBackButton } from 'modules/shares/components/BackButton'
import * as S from './PrototypeHeader.styles'

/**
 * A bare-bones header to show while the Prototype is loading, or in an error
 * state.
 */
export function PrototypeEmptyHeader() {
  const { link: shouldRenderBackButton } = useBackButton()
  return (
    <Navbar data-testid="prototype-empty-header">
      <Navbar.Section>
        {shouldRenderBackButton && (
          <S.BackButtonItem>
            <BackButton />
          </S.BackButtonItem>
        )}
      </Navbar.Section>
    </Navbar>
  )
}
